import { Directive, ElementRef, AfterViewInit, inject, input } from '@angular/core';
import { NgZone } from '@angular/core';

@Directive({
  selector: '[cueScrollIntoView]',
  standalone: true,
})
export class CueScrollIntoViewDirective implements AfterViewInit {
  private el = inject(ElementRef<HTMLElement>);
  private zone = inject(NgZone);

  targetClass = input('', { alias: 'cueScrollIntoView' }); // class name to check

  ngAfterViewInit(): void {
    this.zone.runOutsideAngular(() => {
      requestAnimationFrame(() => {
        if (!this.targetClass() || this.el.nativeElement.classList.contains(this.targetClass())) {
          this.el.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center',
          });
        }
      });
    });
  }
}
